import { Box } from "@mui/material";
import { AccountInvitation } from "@piccadilly-cloud/platform-services";
import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import { UserRegistrationRequest } from "contexts/session/types";
import { useSessionContext } from "contexts/session/useSessionContext";
import { UseFormSetError } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setErrorMessage } from "../utils";

export interface GoogleAuthProps {
  setError: UseFormSetError<any>;
  invitation?: AccountInvitation;
  isRegistration?: boolean;
  setLoading?: (loading: boolean) => void;
  width?: string | number;
  size?: "large" | "medium" | "small";
}

export default function GoogleAuth(props: GoogleAuthProps) {
  const { setError, isRegistration, invitation, setLoading, width, size } =
    props;
  const session = useSessionContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  if (!session.appConfig.userSettings.enableGoogleLogin) {
    return null;
  }

  return (
    <Box sx={{ width: width || "100%" }}>
      <GoogleLogin
        type="standard"
        theme="outline"
        size={size || "large"}
        text={isRegistration ? "signup_with" : "signin_with"}
        shape="rectangular"
        logo_alignment="left"
        width={typeof width === "string" ? width : width?.toString()}
        onSuccess={async (credentials: CredentialResponse) => {
          try {
            setLoading?.(true);
            if (credentials.credential) {
              if (isRegistration && invitation) {
                const request: UserRegistrationRequest = {
                  token: session.token,
                  invitation: invitation,
                  username: "",
                  email: "",
                  password: "",
                };
                await session.registerWithGoogle(
                  request,
                  credentials.credential
                );
              } else {
                await session.loginWithGoogle(
                  credentials.credential,
                  session.token
                );
              }

              const redirectTo =
                searchParams.get("redirect") ||
                searchParams.get("returnTo") ||
                "/";
              navigate(redirectTo);
            }
          } catch (error: any) {
            setError("afterSubmit", {
              ...error,
              message: setErrorMessage(error, isRegistration),
            });
          } finally {
            setLoading?.(false);
          }
        }}
        onError={() => {
          setError("afterSubmit", {
            message: setErrorMessage(
              { message: "Google authentication failed" },
              isRegistration
            ),
          });
        }}
      />
    </Box>
  );
}
